export enum FirebaseDocuments {
  DashboardInsights = 'insights',
  AppConfigSettings = 'settings',
  AppConfigSecurity = 'security',
}
